<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';


export default {
    page: {
        title: "Order",
        meta: [{ name: "description", content: appConfig.description }],
    },
    data() {
        return {
            title: "Enquiry Detail",
            items: [
                {
                    text: "Enquiry Detail",
                },
                {
                    text: "",
                    href: "",
                },
                {
                    text: "",
                    active: true,
                },
            ],
            EnquiryList:[],
            LandingListLoading:false,
            cloudFrontURL: process.env.VUE_APP_BUCKET,
        };
    },
    methods: {
        getLandingList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'enquiry/landing/list/'+ this.$route.params.id)
            .then(response => {
                if (response) {
                    this.EnquiryList = response.data;
                    this.LandingListLoading = true;
                } else {
                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },
    },

    mounted() {
        this.getLandingList();
    },
    components: {
        Layout,
        PageHeader,
    },
};

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
            <div class="card">                        
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <table v-if="LandingListLoading">
                                <tr>
                                    <td><p class="fs-6"><b>Person In Charge: &nbsp;&nbsp;</b></p></td>
                                    <td><p class="fs-6"> {{ EnquiryList.fullname }}</p></td>
                                </tr>
                                <tr>
                                    <td><p class="fs-6"><b>Email &nbsp;</b></p></td>
                                    <td><p class="fs-6">{{ EnquiryList.email }}</p></td>
                                </tr>
                                <tr>
                                    <td><p class="fs-6"><b>Contact Number</b></p></td>
                                    <td><p class="fs-6">{{ EnquiryList.contact_no }}</p></td>
                                </tr>
                                <tr>
                                    <td><p class="fs-6"><b>Company Name</b></p></td>
                                    <td><p class="fs-6">{{ EnquiryList.company_name }}</p></td>
                                </tr>
                                <tr>
                                    <td><p class="fs-6"><b>Company Size</b></p></td>
                                    <td><p class="fs-6">{{ EnquiryList.company_size }}</p></td>
                                </tr>
                                
                            </table>
                        </div>
                    </div>
                </div>
            </div>

    </Layout>
</template>